﻿/* 
    ***** Kolossense 3:1-2,12-13,15,17,22-24
    'As julle dan saam met •Christus opgewek is, streef na dit wat daarbo is, waar Christus aan die regterhand van God sit. 
    Bedink die dinge daarbo, nie die dinge op aarde nie. 
    Daarom, omdat julle God se uitverkore •heiliges en geliefdes is, beklee julleself met innige meelewing, goedheid, 
    nederigheid, sagmoedigheid en geduld. 
    Verdra mekaar en, as enigiemand 'n klagte teen iemand anders het, vergewe mekaar. 
    Soos die Here julle vergewe het, so moet julle ook vergewe. Verder, laat die vrede van Christus in julle harte regeer. 
    As lede van een liggaam, is julle juis daartoe geroep. En wees dankbaar. 
    En wat julle ook al doen, in woord of daad, doen alles in die Naam van die Here Jesus, 
    terwyl julle God die Vader deur Hom dank.
    Slawe, julle moet julle aardse eienaars in alle opsigte gehoorsaam – nie met oëdiens asof julle mense wil behaag nie, 
    maar met 'n opregte hart, uit ontsag vir die Here. 
    Wat julle ook al doen, werk met geesdrif, soos vir die Here, en nie soos vir mense nie, 
    in die wete dat julle 'n erfdeel as beloning van die Here sal ontvang; want julle staan in diens van die Here •Christus.'
*/

//src/desktop/ui/diagrams/unitdiagrams.js
import global from '../../../../../../shared/utils/global.js';
import { getPressureLabelColour, getTemperatureLabelColour, getVoltageLabelColour } from '../../../../../../shared/utils/general.js';
import {
  getActionLogData,
  getStandAloneActionLogData,
  updateStandAloneActionLog,
  updateActionLog,
  updateTrailerName,
  updateSensorFlipRotation
} from './sensors.api.js';
import { updateUnitMetrics } from '../../handleunitdata.js';
import { getSensorHistoryData, getWheelProperties } from './handlesensordata.js';
import { openNewTyreForWheel, openTyreDetail } from '../../../../tyres/tyre-management.js';
import { openGeneralInfoForm } from '../../../../generalinfo/views/generalinfoview.js';
import {
  createSensorValuesDiagramButtonsElement,
  createSensorValuesDiagramOptions,
  createSensorValuesDiagramSpareOptions,
  createSensorValuesDiagramUnpairedOptions,
  createSensorValuesDiagramOptionsElement,
  createSensorNoSignalElement
} from './sensorvaluesdiagram.js';

import { createWheelsDiagramButtonsElement, createAxleInfoElement, openValuesOutOfRangeForm } from './wheelsdiagram.js';
import { exportSensorReportExcel } from '../reports/sensorexcelreport.js';
import { createReportsAxleElements } from '../reports/reports.js';
import { openSensorReport } from '../reports/sensorchartreport.js';
import { cloneObject, addLeadingZero } from '../../../../../../shared/utils/general.js';
import { formatDate, formatZuluTime, formatTime, } from '../../../../../../shared/utils/timeformats.js';
import { SPARE_AXLE, UNPAIRED_AXLE } from '../../../../../../shared/utils/global.js';


import { hideLoading, showLoading } from '../../../../../../shared/components/modal.js';
document.addEventListener('DOMContentLoaded', initTyreContextMenu);

const getWheelIdUnitNumber = (sensor) => {
  const wheelId = String(sensor?.wheelId || sensor?.tyreId || '');
  const unitNumber = parseInt(wheelId.slice(-1), 10);

  return Number.isNaN(unitNumber) ? null : unitNumber;
};

const getWheelIdAxleNumber = (sensor) => {
  const wheelId = String(sensor?.wheelId || sensor?.tyreId || '');
  const axleNumber = parseInt(wheelId.slice(1, 3), 10);

  return Number.isNaN(axleNumber) ? null : axleNumber;
};

const getWheelIdPosition = (sensor) => {
  const wheelId = String(sensor?.wheelId || sensor?.tyreId || '');
  const position = parseInt(wheelId.slice(0, 1), 10);

  return Number.isNaN(position) ? null : position;
};

const buildUnitConfigFromWheelSensors = (unit) => {
  const wheelSensors = (unit?.wheelSensors || [])
    .filter(sensor => {
      const axleNumber = getWheelIdAxleNumber(sensor);
      return axleNumber !== null && axleNumber < SPARE_AXLE;
    });

  if (!wheelSensors.length) return [];

  const unitNumbers = [...new Set(
    wheelSensors
      .map(getWheelIdUnitNumber)
      .filter(unitNumber => unitNumber !== null)
  )].sort((a, b) => a - b);

  return unitNumbers.map(unitNumber => {
    const sensorsForUnit = wheelSensors.filter(sensor =>
      getWheelIdUnitNumber(sensor) === unitNumber
    );

    const axleNumbers = [...new Set(
      sensorsForUnit
        .map(getWheelIdAxleNumber)
        .filter(axleNumber => axleNumber !== null)
    )].sort((a, b) => a - b);

    const axles = axleNumbers.map(axleNumber => {
      const sensorsForAxle = sensorsForUnit.filter(sensor =>
        getWheelIdAxleNumber(sensor) === axleNumber
      );

      const wheelPositions = sensorsForAxle
        .map(getWheelIdPosition)
        .filter(position => position !== null);

      const isDouble = wheelPositions.includes(2) || wheelPositions.includes(3);

      return {
        axle: String(axleNumber).padStart(2, '0'),
        wheelConfig: isDouble ? 1 : 0
      };
    });

    return {
      unitNumber,
      name: unitNumber === 0
        ? unit?.name || 'Truck'
        : unit?.trailers?.find(t => t.trailerNumber === unitNumber)?.name || `Trailer ${unitNumber}`,
      axles,
      axleCount: axles.length,
      sensorCount: sensorsForUnit.length
    };
  });
};

const ensureDiagramUnitConfig = (unit) => {
  if (Array.isArray(unit?.unitConfig) && unit.unitConfig.length > 0) {
    return unit.unitConfig;
  }

  const sensorBasedConfig = buildUnitConfigFromWheelSensors(unit);

  if (sensorBasedConfig.length > 0) {
    unit.unitConfig = sensorBasedConfig;
  }

  return unit.unitConfig || [];
};

export const createDiagramView = (unitdata, diagramView, container) => {

  const diagram = document.getElementById(container);

  while (diagram.hasChildNodes()) {
    diagram.removeChild(diagram.lastChild);
  }
  const diagramFragment = document.createDocumentFragment();

  let diagramDiv = document.createElement('div');
  diagramDiv.id = `${container}diagram`;
  diagramDiv.className = 'unitdiagram';

  diagramFragment.appendChild(diagramDiv);
  diagram.appendChild(diagramFragment);

  if (diagramView === 'SENSORVALUESDIAGRAM') {
    const sensorValuesDiagramButtons = createSensorValuesDiagramButtonsElement(unitdata);
    diagramDiv.appendChild(sensorValuesDiagramButtons);

    const diagramMetricOptionsDiv = createSensorValuesDiagramOptionsElement(unitdata);
    diagramDiv.appendChild(diagramMetricOptionsDiv);
  }
  if (diagramView === 'WHEELSDIAGRAM') {
    const wheelsDiagramButtons = createWheelsDiagramButtonsElement(unitdata);
    diagramDiv.appendChild(wheelsDiagramButtons);
  }
  getDiagramConfiguration(unitdata, diagramView, diagramDiv);
};

async function getDiagramConfiguration(unit, diagramView, diagramDiv) {

  unit.wheelSensors = getWheelProperties(unit.wheelSensors);
  unit.spareSensors = getWheelProperties(unit.spareSensors);
  unit.unpairedSensors = getWheelProperties(unit.unpairedSensors);

  const unitConfig = ensureDiagramUnitConfig(unit);

  if (!unitConfig.length) {
    console.warn('No unit configuration available for diagram:', unit);
    return;
  }

  for (let un = 0; un < unitConfig.length; un++) {

    const unitDiv = createUnitElement(diagramView, unitConfig[un].unitNumber, unit);
    diagramDiv.appendChild(unitDiv);

    const axles = unitConfig[un].axles;
    for (let a = 0; a < axles.length; a++) {
      if (diagramView === 'REPORTSDIAGRAM') {
        const wheelConfig = unit.unitConfig[un].axles[a].wheelConfig;
        let unitNumber = unit.unitType === 'TRAILER' || unit.type === 'trailer' ? unit.unitNumber : unitConfig[un].unitNumber;
        if (!unitNumber) {
          unitNumber = parseInt(unit.wheelSensors[0].wheelId.slice(-1));
        }

        const reportsAxleDiv = createReportsAxleElements(unit, unitNumber, a + +1, wheelConfig);
        unitDiv.appendChild(reportsAxleDiv);
      } else {
        const axleDiv = createAxleElements(diagramView, unit, unitConfig[un].unitNumber, a + +1);
        //createReportsAxleElements(unit, unitNumber, axle)
        unitDiv.appendChild(axleDiv);
      }
    }
  }

  if (unit.spareSensors.length) {
    const unitSpareDiv = createUnitElement(diagramView, SPARE_AXLE, unit);
    diagramDiv.appendChild(unitSpareDiv);

    if (diagramView === 'REPORTSDIAGRAM') {
      const reportsSpareAxleDiv = createReportsAxleElements(unit, 0, 'SPARE', null);
      unitSpareDiv.appendChild(reportsSpareAxleDiv);
    } else {
      const spareAxleDiv = createSpareAxleElements(diagramView, unit);
      unitSpareDiv.appendChild(spareAxleDiv);
    }
  }

  if (unit.spareSensors.length === 0 && unit?.spareWheelSlots > 0) {
    const unitSpareDiv = createUnitElement(diagramView, SPARE_AXLE, unit);
    diagramDiv.appendChild(unitSpareDiv);

    if (diagramView === 'REPORTSDIAGRAM') {
      const reportsSpareAxleDiv = createReportsAxleElements(unit, 0, 'SPARE', null);
      unitSpareDiv.appendChild(reportsSpareAxleDiv);
    } else {
      const spareAxleDiv = createSpareAxleElements(diagramView, unit);
      unitSpareDiv.appendChild(spareAxleDiv);
    }
  }

  if (diagramView !== 'REPORTSDIAGRAM') {
    if (unit.unpairedSensors.length) {
      const unitUnpairedDiv = createUnitElement(diagramView, UNPAIRED_AXLE, unit);
      diagramDiv.appendChild(unitUnpairedDiv);

      const unpairedAxleDiv = createUnpairedAxleElements(diagramView, unit);
      unitUnpairedDiv.appendChild(unpairedAxleDiv);
    }
  }
}

export const createUnitElement = (diagramView, unitNumber, unit) => {

  let diagram = "sv";
  if (diagramView === "WHEELSDIAGRAM") diagram = "w";

  const unitDiv = document.createElement('div');
  unitDiv.className = 'unitbox';

  const linkedtrailer = unit.trailers?.find(trailer => trailer.trailerNumber === unitNumber);
  if (unitNumber !== 0 && linkedtrailer) {

    const unitHeader = createTrailerHeader(diagram, linkedtrailer?.name);
    unitDiv.appendChild(unitHeader);
  }

  if (parseInt(unitNumber) === SPARE_AXLE) {
    const unitHeader = createSpareTyresHeader();
    unitDiv.appendChild(unitHeader);
  }

  if (parseInt(unitNumber) === UNPAIRED_AXLE) {
    const unitHeader = createUnpairedSensorsHeader();
    unitDiv.appendChild(unitHeader);
  }

  return unitDiv;
};

const updateAxleSensors = (axleSensors, axleSensorsHistory) => {
  axleSensorsHistory.forEach(history => {
    // Find matching axleSensor based on wheelId
    const sensor = axleSensors.find(sensor =>
      sensor.Id === history.sensorId
    );

    if (sensor) {
      // Update sensorId, currentPressure, currentTemperature, and currentVoltage from history
      history.Id = sensor.Id;
      history.currentPressure = history.pressure;
      history.currentTemperature = history.temperature;
      history.currentVoltage = history.voltage;
      history.timeUpdated = formatTime(history.payloadTS);

      // Only update label colors if min/max properties exist
      history.pressureLabelColour = 'green';
      if (sensor.minPressure !== undefined && sensor.maxPressure !== undefined) {
        history.pressureLabelColour = getPressureLabelColour(
          parseFloat(history.pressure),
          parseFloat(sensor.minPressure),
          parseFloat(sensor.maxPressure)
        );
      }

      history.temperatureLabelColour = 'green';
      if (sensor.minTemperature !== undefined && sensor.maxTemperature !== undefined) {
        history.temperatureLabelColour = getTemperatureLabelColour(
          parseFloat(history.temperature),
          parseFloat(sensor.maxTemperature)
        );
      }

      history.voltageLabelColour = 'green';
      if (sensor.minVoltage !== undefined && sensor.maxVoltage !== undefined) {
        history.voltageLabelColour = getVoltageLabelColour(
          parseFloat(history.voltage),
          parseFloat(sensor.minVoltage)
        );
      }

      history.signal = true;
    }
  });
};

function createAxleElements(diagramView, unit, unitNumber, axle) {

  const tyreAxleDiv = document.createElement('div');
  tyreAxleDiv.className = 'diagramaxle'; //*wheelaxlediagram

  let axledivclasses = [];
  let axleStatusClass = '';
  const isAxleActive = getAxleActiveStatus(unit, `${addLeadingZero(axle)}`, unitNumber);
  const axleSensors = unit.trailerNumber ?
    unit.wheelSensors.filter(s => parseInt(s.wheelId.slice(1, 3)) === axle && parseInt(s.wheelId.slice(-1)) === unit.trailerNumber) :
    unit.wheelSensors.filter(s => parseInt(s.wheelId.slice(1, 3)) === axle && parseInt(s.wheelId.slice(-1)) === unitNumber);

  let axleSensorsHistory;
  if (global.sensorValuesDiagramDateSelected) {
    // Get the history data for the selected date
    axleSensorsHistory = unit.trailerNumber ? unit.wheelSensorHistory.filter(s => parseInt(s.wheelId.slice(1, 3)) === axle) : unit.wheelSensorHistory.filter(s => parseInt(s.wheelId.slice(1, 3)) === axle && parseInt(s.wheelId.slice(3)) === unitNumber);
    // Example usage with axleSensors and axleSensorsHistory arrays
    updateAxleSensors(axleSensors, axleSensorsHistory);
    console.log(axleSensorsHistory);
  }

  const axleSensorData = global.sensorValuesDiagramDateSelected ? axleSensorsHistory : axleSensors;
  const unitNumberIndex = unit.unitConfig.findIndex(config => config.unitNumber === unitNumber);
  const wheelConfig = unit.unitConfig[unitNumberIndex].axles[axle - 1].wheelConfig;

  let wheel;
  if (wheelConfig === 0) {
    wheel = unit.trailerNumber ? `1${addLeadingZero(axle)}${unit.trailerNumber}` : `1${addLeadingZero(axle)}${unitNumber}`;

    // Create the tyre element using the chosen data source
    const tyre1Div = createTyreElement(diagramView, unit, axle, 1, wheel, axleSensorData);

    // Append the created tyre element to the axle div
    tyreAxleDiv.appendChild(tyre1Div);

    //axle
    if (diagramView === "WHEELSDIAGRAM") {

      isAxleActive ? axleStatusClass = 'axleactive' : axleStatusClass = 'axleinactive';
      axledivclasses = ['shortaxle', axleStatusClass]; //'axleinfo',
      let axleDiv = createAxleElement(unit, axleSensors, axledivclasses);  //***if NO axleSensors but active axle: MAKE a plan!!*/
      tyreAxleDiv.appendChild(axleDiv);

      if (axleSensors.length) {
        let axleInfoDiv = createAxleInfoElement(axleSensors[0]);
        tyreAxleDiv.appendChild(axleInfoDiv);
      }

    } else {
      let axleDiv = document.createElement('div');
      axleDiv.className = 'sensorvaluesaxle';
      tyreAxleDiv.appendChild(axleDiv);
    }

    wheel = unit.trailerNumber ? `4${addLeadingZero(axle)}${unit.trailerNumber}` : `4${addLeadingZero(axle)}${unitNumber}`;
    let tyre4Div = createTyreElement(diagramView, unit, axle, 4, wheel, axleSensorData);
    tyreAxleDiv.appendChild(tyre4Div);

  } else {

    for (let s = 1; s <= 2; s++) {
      wheel = unit.trailerNumber ? `${s}${addLeadingZero(axle)}${unit.trailerNumber}` : `${s}${addLeadingZero(axle)}${unitNumber}`;
      const tyreDiv = createTyreElement(diagramView, unit, axle, s, wheel, axleSensorData);
      tyreAxleDiv.appendChild(tyreDiv);
    }

    isAxleActive ? axleStatusClass = 'axleactive' : axleStatusClass = 'axleinactive';
    //console.log(isAxleActive)
    axledivclasses = ['shortaxle', axleStatusClass]; //'axleinfo', 

    if (diagramView === "WHEELSDIAGRAM") {
      let axleDiv = createAxleElement(unit, axleSensors, axledivclasses);
      tyreAxleDiv.appendChild(axleDiv);

      if (axleSensors.length) {
        let axleInfoDiv = createAxleInfoElement(axleSensors[0]);
        tyreAxleDiv.appendChild(axleInfoDiv);
      }
    } else {
      let axleDiv = document.createElement('div');
      axleDiv.className = 'sensorvaluesaxle';
      tyreAxleDiv.appendChild(axleDiv);
    }

    for (let s = 3; s <= 4; s++) {
      wheel = unit.trailerNumber ? `${s}${addLeadingZero(axle)}${unit.trailerNumber}` : `${s}${addLeadingZero(axle)}${unitNumber}`;
      let tyreDiv = createTyreElement(diagramView, unit, axle, s, wheel, axleSensorData);
      tyreAxleDiv.appendChild(tyreDiv);
    }
  }

  return tyreAxleDiv;
}

function createSpareAxleElements(diagramView, unit) {

  const tyreSpareAxleDiv = document.createElement('div');
  tyreSpareAxleDiv.className = 'diagramaxle';

  const axleSensors = unit.spareSensors;
  let axleSensorsHistory;

  if (global.sensorValuesDiagramDateSelected) {
    axleSensorsHistory = unit.spareSensorHistory;

    // Example usage with axleSensors and axleSensorsHistory arrays
    updateAxleSensors(axleSensors, axleSensorsHistory);
    console.log(axleSensorsHistory);
  }

  const axleSensorData = global.sensorValuesDiagramDateSelected ? axleSensorsHistory : axleSensors;

  for (let s = 0; s < axleSensors.length; s++) {
    const tyreDiv = createSpareTyreElement(diagramView, unit, s + +1, axleSensorData);
    tyreSpareAxleDiv.appendChild(tyreDiv);
  }

  if (axleSensors.length === 0 && unit?.spareWheelSlots > 0) {
    for (let s = 0; s < unit.spareWheelSlots; s++) {
      const tyreDiv = createSpareTyreElement(diagramView, unit, s + +1, axleSensorData);
      tyreSpareAxleDiv.appendChild(tyreDiv);
    }
  }

  //Spare Axle
  if (diagramView === 'WHEELSDIAGRAM') {
    const isAxleActive = getAxleActiveStatus(unit, '17', (unit.trailerNumber && unit.trailerNumber > 0) ? 0 : parseInt(axleSensors[0].wheelId.slice(-1)));

    let axleStatusClass = ``;
    isAxleActive ? axleStatusClass = `spareaxleactive` : axleStatusClass = `spareaxleinactive`;

    const spareAxle = createSpareAxleElement(unit, axleSensors, axleStatusClass);
    tyreSpareAxleDiv.appendChild(spareAxle);

    if (axleSensors.length) {
      const axleInfoDiv = createAxleInfoElement(axleSensors[0]);
      tyreSpareAxleDiv.appendChild(axleInfoDiv);
    }

  }

  return tyreSpareAxleDiv;
}

function createUnpairedAxleElements(diagramView, unit) {

  const unpairedAxleDiv = document.createElement('div');
  unpairedAxleDiv.className = 'diagramaxle unpaired-sensors-grid';

  const axleSensors = unit.unpairedSensors;

  for (let s = 0; s < axleSensors.length; s++) {
    let sensorElement;

    if (diagramView === "SENSORVALUESDIAGRAM") {
      sensorElement = createUnpairedSensorValuesElement(unit, s, axleSensors);
    } else {
      sensorElement = createUnpairedTyreElement(unit, s, axleSensors);
    }

    sensorElement.classList.add('unpaired-sensor-item');
    unpairedAxleDiv.appendChild(sensorElement);
  }

  return unpairedAxleDiv;
}

function createUnpairedSensorValuesElement(unit, tyreIndex, axleSensors) {

  const wheel = document.createElement('div');
  wheel.className = 'sensorvaluesinfo';
  const tyreNameDiv = createUnpairedTyreNameElement(tyreIndex);
  tyreNameDiv.className = 'sensorvaluestyrename';
  let tyreDiv = document.createElement('div');
  //sensorType = 'tyre-correct';  
  tyreDiv = createSensorValuesDiagramUnpairedOptions(tyreDiv, axleSensors, tyreIndex);
  tyreDiv.className = 'sensorvaluesdefault';
  wheel.appendChild(tyreNameDiv);
  wheel.appendChild(tyreDiv);

  wheel.onclick = function (e) {
    e.stopImmediatePropagation();
    openTyreContextMenu(e, unit, axleSensors[tyreIndex]);
  };

  return wheel;
}

function createUnpairedTyreElement(unit, tyreIndex, axleSensors) {

  const wheel = document.createElement('div');
  //wheel.className = 'sensorvaluesinfo';
  const tyreNameDiv = createUnpairedTyreNameElement(tyreIndex);
  const tyredivclasses = ['wheeldefault', 'tyre-unpaired'];
  let tyreDiv = document.createElement('div');
  tyreDiv.classList.add(...tyredivclasses);

  //const tyreNameDiv = createTyreNameElement(SPARE_AXLE, tyre);

  wheel.appendChild(tyreNameDiv);
  wheel.appendChild(tyreDiv);

  wheel.onclick = function (e) {
    e.stopImmediatePropagation();
    openTyreContextMenu(e, unit, axleSensors[tyreIndex]);
  };

  return wheel;
}

function createSpareTyreElement(diagramView, unit, tyre, axleSensors) {

  const wheel = document.createElement('div');

  const tyreNameDiv = createTyreNameElement(SPARE_AXLE, tyre);

  let tyreDiv = document.createElement('div');
  //const tyreArrayIndex = getTyreArrayIndexTest(tyre, axleSensors);
  if (axleSensors.length > 0) {

    let tyredivclasses = ['wheeldefault'];
    let sensorType = 'tyre-correct';

    if (!axleSensors[tyre + -1]?.signal) {
      sensorType = 'tyre-nosignal';
    } else {
      if (axleSensors[tyre + -1]?.hasOwnProperty('sensorType')
        && axleSensors[tyre + -1]?.sensorType !== "") {
        sensorType = axleSensors[tyre + -1]?.sensorType || 'tyre-correct';
      }
    }

    if (diagramView === "SENSORVALUESDIAGRAM") {
      wheel.className = 'sensorvaluesinfo';
      tyredivclasses = ['sensorvaluesdefault'];
      tyreNameDiv.className = 'sensorvaluestyrename';
      tyreDiv = createSensorValuesDiagramSpareOptions(tyreDiv, axleSensors, tyre);
    } else {
      const axleSensor = axleSensors[tyre + -1];
      tyreDiv.id = `wheel${axleSensor.Id}`;
      tyredivclasses = ['wheeldefault', sensorType];
    }

    tyreDiv.classList.add(...tyredivclasses);

    wheel.appendChild(tyreNameDiv);
    wheel.appendChild(tyreDiv);
  } else {

    let tyredivclasses = ['wheeldefault'];
    let sensorType = 'tyre-nosignal';

    if (diagramView === "SENSORVALUESDIAGRAM") {

      wheel.className = 'sensorvaluesinfo';

      tyredivclasses = ['sensorvaluesdefault'];

      tyreNameDiv.className = 'sensorvaluestyrename';

      tyreDiv.id = 'wheelnosignal' + tyre;
      const sensorNoSignalDiv = createSensorNoSignalElement();
      tyreDiv.appendChild(sensorNoSignalDiv);

    } else {

      tyreDiv.id = `spare${tyre}`;
      tyredivclasses = ['wheeldefault', sensorType];
    }

    tyreDiv.classList.add(...tyredivclasses);

    wheel.appendChild(tyreNameDiv);
    wheel.appendChild(tyreDiv);

  }

  wheel.onclick = function (e) {
    e.stopImmediatePropagation();
    openTyreContextMenu(e, unit, axleSensors[tyre + -1]);
  };


  return wheel;
}

function createAxleElement(unit, axleSensors, axledivclasses) {

  const axleDiv = document.createElement('div');
  axleDiv.className = 'axle';

  const axleSvg = document.createElement('svg');
  axleSvg.id = axleSensors.length > 0
    ? `axle${axleSensors[0].wheelId.slice(1)}`
    : 'axle_nosignal';
  axleSvg.classList.add(...axledivclasses);
  axleDiv.appendChild(axleSvg);

  const axleSensorsCloned = cloneObject(axleSensors);
  axleDiv.onclick = function (e) {
    e.stopImmediatePropagation();
    openValuesOutOfRangeForm(unit, axleSensorsCloned);
  };

  return axleDiv;
}

function createSpareAxleElement(unit, axleSensors, axleStatusClass) {

  const axleDiv = document.createElement('div');
  axleDiv.id = `axle17`;
  axleDiv.className = `spareaxle ${axleStatusClass}`;
  //axleDiv.classList.add(...axledivclass);

  const axleSensorsCloned = cloneObject(axleSensors);
  axleDiv.onclick = function (e) {
    e.stopImmediatePropagation();
    openValuesOutOfRangeForm(unit, axleSensorsCloned);
  };

  return axleDiv;
}

export const getAxleActiveStatus = (unit, axleNo, unitNumber) => {

  let axleRange = {};

  if (unitNumber === 0 && Array.isArray(unit.axleRanges)) {
    axleRange = unit?.axleRanges.find(ar => ar.axleNumber === axleNo);
  }

  if (unitNumber > 0) {

    if (unit?.trailerNumber === unitNumber) {
      axleRange = unit?.axleRanges.find(ar => ar.axleNumber === axleNo);
    } else {
      // Find the matching trailer where trailerNumber matches unitNumber
      const matchingTrailer = unit?.trailers.find(trailer => trailer.trailerNumber === unitNumber);

      if (matchingTrailer && Array.isArray(matchingTrailer.axleRanges)) {
        axleRange = matchingTrailer?.axleRanges.find(ar => ar.axleNumber === axleNo);
      }
    }
  }

  if (axleRange && Object.keys(axleRange).length > 0) {

    return (
      axleRange.recommendedPressure > 0 ||
      axleRange.pressureDeviationAllowedLow > 0 ||
      axleRange.pressureDeviationAllowedHigh > 0 ||
      axleRange.minPressure > 0 ||
      axleRange.maxPressure > 0 ||
      axleRange.maxTemperature > 0 ||
      axleRange.minVoltage > 0
    );
  } else { return false; }
};

function createTyreNameElement(axle, tyre) {
  const tyreNameDiv = document.createElement('div');
  tyreNameDiv.className = 'tyrename';
  tyreNameDiv.innerText = `A${axle}-T${tyre}`;
  if (axle === SPARE_AXLE) tyreNameDiv.innerText = `S-${tyre}`;
  return tyreNameDiv;
}

function createUnpairedTyreNameElement(tyreIndex) {
  const tyre = tyreIndex + 1;
  const tyreNameDiv = document.createElement('div');
  tyreNameDiv.className = 'tyrename';
  tyreNameDiv.innerText = `U-${tyre}`;
  return tyreNameDiv;
}

export function getTyreArrayIndexTest(tyre, axleSensors) {
  let tyreArrayIndex = -1;
  for (let s = 0; s < axleSensors.length; s++) {
    if (parseInt(axleSensors[s].wheelId.slice(0, 1)) === tyre) {
      //tyreArrayIndex = tyre;
      return s;
    }
  }
  return tyreArrayIndex;
}

function createTyreElement(diagramView, unit, axle, tyre, wheel, axleSensors) {

  const wheelDiv = document.createElement('div');

  const tyreNameDiv = createTyreNameElement(axle, tyre);

  let tyreDiv = document.createElement('div');
  let tyreArrayIndex = 0;
  let sensorType = 'tyre-correct';
  if (axleSensors && axleSensors.length > 0) {

    tyreArrayIndex = getTyreArrayIndexTest(tyre, axleSensors);
    let tyredivclasses = ['wheeldefault'];

    if (
      tyreArrayIndex === -1 ||
      !axleSensors[tyreArrayIndex] || // Ensures axleSensors[tyreArrayIndex] is not undefined/null
      !('signal' in axleSensors[tyreArrayIndex]) // Ensures the property exists
    ) {
      sensorType = 'tyre-nosignal';
    } else {
      if (axleSensors.filter(as => parseInt(as.wheelId.slice(0, 1)) === tyre)[0].hasOwnProperty('sensorType')
        && axleSensors.filter(as => parseInt(as.wheelId.slice(0, 1)) === tyre)[0].sensorType !== "") {
        sensorType = axleSensors.filter(as => parseInt(as.wheelId.slice(0, 1)) === tyre)[0].sensorType;
      }
    }

    if (diagramView === "SENSORVALUESDIAGRAM") {
      wheelDiv.className = 'sensorvaluesinfo';
      tyredivclasses = ['sensorvaluesdefault'];
      tyreNameDiv.className = 'sensorvaluestyrename';
      tyreDiv = createSensorValuesDiagramOptions(tyreDiv, tyreArrayIndex, axleSensors, sensorType);
    } else {
      //tyreDiv.id = 'wheel' + tyre + axleSensors[0].wheelId.slice(1);
      const axleSensor = axleSensors.find(s => s.wheelId === tyre + axleSensors[0].wheelId.slice(1));
      if (axleSensor) {
        tyreDiv.id = `wheel${axleSensor.Id}` || tyre + axleSensors[0].wheelId.slice(1);
      } else {
        tyreDiv.id = tyre + axleSensors[0].wheelId.slice(1);
      }
      tyredivclasses = ['wheeldefault', sensorType];
    }

    tyreDiv.classList.add(...tyredivclasses);

    wheelDiv.appendChild(tyreNameDiv);
    wheelDiv.appendChild(tyreDiv);
  } else {

    tyreDiv.id = 'wheelnosignal' + tyre;

    let tyredivclasses = ['wheeldefault'];
    sensorType = 'tyre-nosignal';

    if (diagramView === "SENSORVALUESDIAGRAM") {

      wheelDiv.className = 'sensorvaluesinfo';

      tyredivclasses = ['sensorvaluesdefault'];

      tyreNameDiv.className = 'sensorvaluestyrename';

      let sensorNoSignalDiv = createSensorNoSignalElement();
      tyreDiv.appendChild(sensorNoSignalDiv);

    } else {
      tyredivclasses = ['wheeldefault', sensorType];

    }

    tyreDiv.classList.add(...tyredivclasses);

    wheelDiv.appendChild(tyreNameDiv);
    wheelDiv.appendChild(tyreDiv);

  }

  wheelDiv.onclick = function (e) {
    e.stopImmediatePropagation();
    const unitAxleWheel = getWheelData(wheel, axleSensors);
    openTyreContextMenu(e, unit, unitAxleWheel);
  };

  return wheelDiv;
}

function getWheelData(wheel, axleSensors) {
  // Check if wheel matches any SensorName in the objects array
  const axleSensor = axleSensors.find(s => s.wheelId.toString() === wheel.toString());

  // If a match is found, return the existing array unchanged
  if (axleSensor) {
    return axleSensor;
  }

  // Find an object to copy certain properties from (for this example, we copy from the first object)
  const sourceObject = axleSensors[0];
  const sensor = {};

  // Assign all properties of the sourceObject to the newObject with specified exceptions
  for (let key in sourceObject) {
    if (sourceObject.hasOwnProperty(key)) {
      if (key === 'unitNumber' || key === 'axle' || key === 'recommendedPressure' || key === 'pressureDeviationAllowedLow' || key === 'pressureDeviationAllowedHigh' ||
        key === 'maxTemperature' || key === 'minVoltageValue' || key === 'maxPressure' || key === 'minPressure') {
        sensor[key] = sourceObject[key];
      } else {
        sensor[key] = null;
      }
    }
  }

  sensor.wheelId = wheel;
  sensor.tyreName = `A${parseInt(wheel.slice(1, 3))}-T${wheel.slice(0, 1)}`;
  sensor.sensorType = 'noSignal';
  sensor.wheelType = 'wheelinactive';

  return sensor;
}

function createSpareTyresHeader() {

  const spareTyresHeader = document.createElement('div');
  spareTyresHeader.className = 'unitbox';

  const header = document.createElement('h6');
  //const headerLabel = document.createElement('div');
  //headerLabel.className = 'edittrailername';

  //const headerText = document.createElement('span');
  header.id = "sparetyres";
  header.innerText = "Spare Tyres";
  //headerLabel.appendChild(headerText);
  //header.appendChild(headerLabel);
  spareTyresHeader.appendChild(header);

  return spareTyresHeader;
}

const createUnpairedSensorsHeader = () => {

  const unpairedSensorsHeader = document.createElement('div');
  unpairedSensorsHeader.className = 'unitbox';

  const header = document.createElement('h6');
  //const headerLabel = document.createElement('div');
  //headerLabel.className = 'edittrailername';

  //const headerText = document.createElement('span');
  header.id = "unpairedtyres";
  header.innerText = "Unpaired Sensors";
  unpairedSensorsHeader.appendChild(header);

  return unpairedSensorsHeader;
};

export async function displaySensorUpdates(unit, data) {

  unit = updateUnitMetrics(unit, data);
  // const cName  = `${(unit.wheelSensors.find(s => s.id === data.wheelSensorUID) ||
  //     unit.spareSensors.find(s => s.id === data.wheelSensorUID)).sensorType}`;
  if (document.getElementById(`wheel${data.wheelSensorUID}`)) {
    document.getElementById(`wheel${data.wheelSensorUID}`).className = `wheeldefault ${(unit.wheelSensors.find(s => s.Id === data.wheelSensorUID) ||
      unit.spareSensors.find(s => s.Id === data.wheelSensorUID)).sensorType}`;
  }
  if (document.getElementById(`sv${data.wheelSensorUID}timeupdated`)) {
    document.getElementById(`sv${data.wheelSensorUID}timeupdated`).innerText = formatTime(data.payloadTS);
  }
  if (document.getElementById(`sv${data.wheelSensorUID}sensorid`)) {
    document.getElementById(`sv${data.wheelSensorUID}sensorid`).innerText = data.wheelSensorUID;
  }
  const pressureElement = document.getElementById(`sv${data.wheelSensorUID}pressure`);
  if (pressureElement) {
    pressureElement.innerHTML = '';
    const pressure = parseFloat(data.currentPressure).toFixed(2);
    pressureElement.innerText = `${pressure} bar`;
    pressureElement.className = `sensorvalues ${(unit.wheelSensors.find(s => s.Id === data.wheelSensorUID) ||
      unit.spareSensors.find(s => s.Id === data.wheelSensorUID)).pressureLabelColour}`;
  }
  if (document.getElementById(`sv${data.wheelSensorUID}temperature`)) {
    document.getElementById(`sv${data.wheelSensorUID}temperature`).innerText = `${data.currentTemperature} °C`;//`${data.currentTemperature} ${String.fromCharCode(176)}C`
    document.getElementById(`sv${data.wheelSensorUID}temperature`).className = `sensorvalues ${(unit.wheelSensors.find(s => s.Id === data.wheelSensorUID) ||
      unit.spareSensors.find(s => s.Id === data.wheelSensorUID)).temperatureLabelColour}`;
  }
  if (document.getElementById(`sv${data.wheelSensorUID}voltage`)) {
    document.getElementById(`sv${data.wheelSensorUID}voltage`).innerText = `${data.currentVoltage} V`;
    document.getElementById(`sv${data.wheelSensorUID}voltage`).className = `sensorvalues ${(unit.wheelSensors.find(s => s.Id === data.wheelSensorUID) ||
      unit.spareSensors.find(s => s.Id === data.wheelSensorUID)).voltageLabelColour}`;
  }

  let sensorSignalStrengthElement = document.getElementById(`sv${data.wheelSensorUID}signalstrength`);
  if (sensorSignalStrengthElement) {
    const sensor = unit.wheelSensors.find(s => s.Id === data.wheelSensorUID) ||
      unit.spareSensors.find(s => s.Id === data.wheelSensorUID);
    if (sensor) {
      sensorSignalStrengthElement.innerHTML = '';
      sensorSignalStrengthElement.className = 'signalstrengthbar';
      const signalStrength = sensor.repeater.reliabilityDiff;
      sensorSignalStrengthElement = createSignalStrengthBar(sensorSignalStrengthElement, signalStrength);
    }
  }

  const rotationElement = document.getElementById(`sv${data.wheelSensorUID}rotation`);
  if (rotationElement) {
    if (Math.abs(parseInt(data.currentRotation)) < 1000) {
      if (parseInt(data.currentRotation) === -107) {
        rotationElement.className = 'sensorvalues red';
        rotationElement.innerText = 'Sensor Failed';
      } else {
        rotationElement.className = 'sensorvalues green';
        rotationElement.innerText = 'Stopped';
      }
    } else {
      rotationElement.className = 'sensorvalues signalgreen';
      rotationElement.innerText = 'Rolling';
    }
  }
}

export function createSignalStrengthBar(sensorSignalStrengthDiv, signalStrength) {

  for (let b = 1; b <= 6; b++) {
    const block = document.createElement('div');
    block.className = 'signalblock';
    block.id = 'signalblock' + b;

    if (b <= 2 && b <= signalStrength) {
      block.classList.add('signalred');
    }
    if (b > 2 && b <= 4 && b <= signalStrength) {
      block.classList.add('signalyellow');
    }
    if (b > 4 && b <= signalStrength) {
      block.classList.add('signalgreen');
    }
    sensorSignalStrengthDiv.appendChild(block);
  }
  return sensorSignalStrengthDiv;
}

export function createTrailerHeader(diagram, trailerName) {

  const trailerHeader = document.createElement('div');

  const header = document.createElement('h6');
  const headerLabel = document.createElement('div');

  const linkIcon = document.createElement('svg');
  linkIcon.className = 'linkicon';
  const headerText = document.createElement('span');

  headerLabel.appendChild(linkIcon);
  headerLabel.appendChild(headerText);

  trailerHeader.className = 'unitbox';
  headerText.id = `${diagram}trailer${trailerName}`;
  headerText.innerText = `${trailerName}`;

  header.appendChild(headerLabel);
  trailerHeader.appendChild(header);

  return trailerHeader;
}

function getWheelSensorId(wheel) {
  return wheel?.sensorId || wheel?.Id || wheel?.id || null;
}

// Keep the already-rendered unit diagram honest after the New Tyre screen creates
// and fits a tyre. The API remains authoritative; this only updates the local
// wheel/sensor objects and any visible tyre labels so the user does not have to
// leave and re-open the unit to see the fitment.
function syncTyreAssociationLocally(unit, wheel, tyre = {}) {
  const externalTyreId = tyre?.externalTyreId;
  if (!externalTyreId || !wheel) return;

  const apply = (target) => {
    if (!target) return;
    target.externalTyreId = externalTyreId;
    target.tyre = {
      ...(target.tyre || {}),
      ...tyre,
      externalTyreId
    };

    if (tyre.tyreTreadDepth !== undefined) {
      target.tyreTreadDepth = tyre.tyreTreadDepth;
    }
  };

  apply(wheel);

  const sensorId = String(getWheelSensorId(wheel) ?? '');
  const wheelId = String(wheel?.wheelId ?? '');

  const sensorArrays = [
    unit?.wheelSensors,
    unit?.spareSensors,
    unit?.unpairedSensors
  ].filter(Array.isArray);

  for (const sensors of sensorArrays) {
    const match = sensors.find((sensor) => {
      const candidateSensorId = String(getWheelSensorId(sensor) ?? '');
      const candidateWheelId = String(sensor?.wheelId ?? '');
      return (
        (sensorId && candidateSensorId === sensorId) ||
        (wheelId && candidateWheelId === wheelId)
      );
    });

    if (match) {
      apply(match);
      break;
    }
  }

  if (!sensorId) return;

  const tyreIdEl = document.getElementById(`sv${sensorId}tyreid`);
  if (tyreIdEl) tyreIdEl.innerText = externalTyreId;

  const treadEl = document.getElementById(`sv${sensorId}treaddepth`);
  if (treadEl && tyre.tyreTreadDepth !== undefined && tyre.tyreTreadDepth !== null && tyre.tyreTreadDepth !== '') {
    treadEl.innerText = `${tyre.tyreTreadDepth} mm`;
  }
}

function updateWheelFlipRotationLocally(unit, wheel, flipRotation) {
  wheel.flipRotation = flipRotation;

  const matchingWheel =
    unit?.wheelSensors?.find(s => s.wheelId === wheel.wheelId) ||
    unit?.spareSensors?.find(s => s.wheelId === wheel.wheelId);

  if (matchingWheel) {
    matchingWheel.flipRotation = flipRotation;
  }
}

async function handleTemporaryRotationFix(unit, wheel) {
  const sensorId = getWheelSensorId(wheel);

  if (!sensorId) {
    alert('This wheel does not have a sensor ID, so the temporary rotation fix cannot be updated.');
    return;
  }

  const newValue = !Boolean(wheel.flipRotation);

  const slider = document.getElementById('tyreMenuFlipRotation');
  if (slider) {
    slider.checked = newValue;
  }

  document.getElementById('loadingBoxText').innerText = 'Updating temporary rotation fix... ';
  showLoading();

  const result = await updateSensorFlipRotation(sensorId, newValue);

  hideLoading();

  if (!result.success) {
    alert(result.message || 'Could not update temporary rotation fix.');

    if (slider) {
      slider.checked = Boolean(wheel.flipRotation);
    }

    return;
  }

  updateWheelFlipRotationLocally(unit, wheel, newValue);

  createDiagramView(unit, 'SENSORVALUESDIAGRAM', 'middlepane');
}

let currentContext = {
  unit: null,
  wheel: null,
};

const hideTyreContextMenu = () => {
  const menu = document.getElementById('tyrecontextmenu');
  const closeMenu = document.getElementById('closetyremenu');
  if (!menu || !closeMenu) return;

  menu.classList.remove('show');
  // optional: move offscreen, cannot overlap anything
  menu.style.left = '-9999px';
  menu.style.top = '-9999px';
  closeMenu.style.display = 'none';
};

function initTyreContextMenu() {
  const menu = document.getElementById('tyrecontextmenu');
  const closeMenu = document.getElementById('closetyremenu');

  if (!menu || !closeMenu) {
    console.error('Tyre context menu elements not found');
    return;
  }

  // ONE handler for the menu click, forever
  menu.addEventListener('click', async (ev) => {
    const item = ev.target.closest('li');
    if (!item) return;

    ev.stopPropagation();
    ev.preventDefault();

    const unit = currentContext.unit;
    const wheel = currentContext.wheel;

    if (!unit || !wheel) {
      console.warn('Context menu clicked without valid context');
      hideTyreContextMenu();
      return;
    }

    hideTyreContextMenu();

    const action = item.dataset.action || item.innerText.trim();

    switch (action) {
      case 'edit-tyre-info':
      case 'Edit Tyre Info': {
        // Resolve this wheel to its tyre. When one is fitted, open the new
        // tm-detail view via the tyre area's own router (single source of truth
        // for how detail opens); pass the richest seed we already hold for an
        // instant paint — detail refetches the authoritative record by id.
        const externalTyreId =
          wheel?.tyre?.externalTyreId || wheel?.externalTyreId || null;

        if (externalTyreId) {
          openTyreDetail({ ...(wheel.tyre || {}), externalTyreId });
        } else {
          // Empty paired wheel: open the SAME New Tyre screen used by the Tyre
          // Management dashboard, but carry this wheel's sensor as the target.
          // The form saves the tyre, fits it to this sensor, then opens its detail.
          const sensorId = getWheelSensorId(wheel);

          if (!sensorId) {
            alert('This wheel does not have a sensor ID, so a tyre cannot be fitted to it.');
            break;
          }

          const wheelLabel = wheel?.wheelId ? `wheel ${wheel.wheelId}` : 'selected wheel';
          openNewTyreForWheel({
            targetSensorId: sensorId,
            fitTargetLabel: `${wheelLabel} · sensor ${sensorId}`,
            onAssociated: (tyre) => syncTyreAssociationLocally(unit, wheel, tyre)
          });
        }
        break;
      }

      case 'temporary-rotation-fix':
        await handleTemporaryRotationFix(unit, wheel);
        break;
      case 'wheel-report':
      case 'Wheel Report':
        document.body.style.cursor = 'none';
        document.getElementById('loadingBoxText').innerText = 'Collecting Report Data... ';
        showLoading();

        let workingWheel = wheel;

        // keep your spare-wheel logic as-is
        if (typeof workingWheel === 'object' && workingWheel !== null && 'wheelId' in workingWheel) {
          const axle = workingWheel.wheelId.slice(1, 3);
          if (axle === SPARE_AXLE.toString()) {
            const s = unit.spareSensors.findIndex(sensor => sensor.wheelId === workingWheel.wheelId);
            workingWheel.recommendedPressure = unit.spareSensors[s]?.recommendedPressure || 3.5;
            workingWheel.pressureDeviationAllowedLow = unit.spareSensors[s]?.pressureDeviationAllowedLow || 10;
            workingWheel.pressureDeviationAllowedHigh = unit.spareSensors[s]?.pressureDeviationAllowedHigh || 10;
            workingWheel.minPressure = unit.spareSensors[s]?.minPressure;
            workingWheel.maxPressure = unit.spareSensors[s]?.maxPressure;
            workingWheel.maxTemperature = unit.spareSensors[s]?.maxTemperature;
            workingWheel.minVoltageValue = unit.spareSensors[s]?.minVoltageValue;
          }
        } else if (typeof workingWheel === 'string') {
          const axle = workingWheel.slice(1, 3);
          if (axle === SPARE_AXLE.toString()) {
            const s = unit.spareSensors.findIndex(sensor => sensor.wheelId === workingWheel);
            workingWheel = {
              recommendedPressure: unit.spareSensors[s]?.recommendedPressure || 3.5,
              pressureDeviationAllowedLow: unit.spareSensors[s]?.pressureDeviationAllowedLow || 10,
              pressureDeviationAllowedHigh: unit.spareSensors[s]?.pressureDeviationAllowedHigh || 10,
              minPressure: unit.spareSensors[s].minPressure,
              maxPressure: unit.spareSensors[s].maxPressure,
              maxTemperature: unit.spareSensors[s].maxTemperature,
              minVoltageValue: unit.spareSensors[s].minVoltageValue,
            };
          }
        }

        const sensorData = await getSensorHistoryData(unit, workingWheel, null);
        hideLoading();
        document.body.style.cursor = 'default';
        openSensorReport(unit, sensorData);
        break;

      case 'export-wheel-report':
      case 'Export Wheel Report (Excel)':
        document.body.style.cursor = 'none';
        document.getElementById('loadingBoxText').innerText = 'Collecting Export Data... ';
        showLoading();

        try {
          await exportSensorReportExcel(unit, wheel);
        } finally {
          hideLoading();
          document.body.style.cursor = 'default';
        }
        break;

      case 'notification-log':
      case 'Notification Log':
        openActionLogForm(unit, wheel);
        break;
      case 'general-information':
      case 'General Information':
        openGeneralInfoForm('wheel', unit, wheel);
        break;
    }
  });

  // one handler for overlay close
  closeMenu.addEventListener('click', () => {
    hideTyreContextMenu();
  });
}

const openTyreContextMenu = (event, unit, wheel) => {
  const menu = document.getElementById('tyrecontextmenu');
  const closeMenu = document.getElementById('closetyremenu');

  if (!menu || !closeMenu) return;

  // Store latest context for the single global handler
  currentContext.unit = unit;
  currentContext.wheel = wheel;

  const notificationLogItem = document.querySelector('#tyrecontextmenu li[data-action="notification-log"]');
  const wheelReportItem = document.querySelector('#tyrecontextmenu li[data-action="wheel-report"]');
  const exportWheelReportItem = document.querySelector('#tyrecontextmenu li[data-action="export-wheel-report"]');
  const editTyreInfoItem = document.querySelector('#tyrecontextmenu li[data-action="edit-tyre-info"]');

  const temporaryRotationFixItem = document.querySelector('#tyrecontextmenu li[data-action="temporary-rotation-fix"]');

  const temporaryRotationFixInput = document.getElementById('tyreMenuFlipRotation');

  if (temporaryRotationFixInput) {
    temporaryRotationFixInput.checked = !!wheel?.flipRotation;
  }

  const sensorId = wheel?.sensorId || wheel?.Id || wheel?.id || null;

  // wheelId === 1180 means unpaired
  if (wheel?.wheelId === '1180' || !sensorId) {
    notificationLogItem.classList.add('contextmenu-item-disabled');
    wheelReportItem.classList.add('contextmenu-item-disabled');
    exportWheelReportItem.classList.add('contextmenu-item-disabled');
    editTyreInfoItem.classList.add('contextmenu-item-disabled');
    temporaryRotationFixItem?.classList.add('contextmenu-item-disabled');
  } else {
    notificationLogItem.classList.remove('contextmenu-item-disabled');
    wheelReportItem.classList.remove('contextmenu-item-disabled');
    exportWheelReportItem.classList.remove('contextmenu-item-disabled');
    editTyreInfoItem.classList.remove('contextmenu-item-disabled');
    temporaryRotationFixItem?.classList.remove('contextmenu-item-disabled');
  }

  event.preventDefault();
  event.stopPropagation();

  // --- POSITION THE MENU NEAR THE MOUSE ---
  const { clientX, clientY } = event;

  // temporarily show to measure
  menu.style.left = '0px';
  menu.style.top = '0px';
  menu.classList.add('show');

  const menuWidth = menu.offsetWidth || 160;
  const menuHeight = menu.offsetHeight || 120;
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  let left = clientX;
  let top = clientY;

  if (left + menuWidth > viewportWidth) {
    left = viewportWidth - menuWidth - 8;
  }
  if (top + menuHeight > viewportHeight) {
    top = viewportHeight - menuHeight - 8;
  }

  menu.style.left = `${left}px`;
  menu.style.top = `${top}px`;

  // Show overlay
  closeMenu.style.display = 'block';
};

// function openEditTyreIdForm(unit, wheel) {

//   document.body.style.cursor = 'wait';

//   const editTyreInfo = document.getElementById('edittyreinfomodal');
//   const edittyreidform = document.getElementById('edittyreidform');
//   const errorMessageEl = document.getElementById('etfErrorMessage');

//   let closeModal = document.getElementById("closeedittyreidmodal");
//   closeModal.onclick = function () {
//     editTyreInfo.style.display = "none";
//   };

//   // Reset form and error state
//   edittyreidform.reset();
//   if (errorMessageEl) {
//     errorMessageEl.style.display = 'none';
//     errorMessageEl.textContent = '';
//   }

//   // Wheel id + label
//   const wheelId = wheel.wheelId;
//   document.getElementById('etfSensorName').value = wheelId;

//   const axleNo = wheelId.slice(1, 3);
//   const tyreNo = wheelId.slice(0, 1);
//   const wheelLabel = `A${parseInt(axleNo, 10)}-T${tyreNo}`;

//   // Lookup tyreInfo
//   const isSpare = axleNo === SPARE_AXLE.toString();
//   const tyreInfo = isSpare
//     ? unit.spareSensors.find(s => s.wheelId === wheelId)
//     : unit.wheelSensors.find(s => s.wheelId === wheelId);

//   if (!tyreInfo) {
//     if (errorMessageEl) {
//       errorMessageEl.textContent = `Sensor ID for wheel ${wheelLabel} not found.`;
//       errorMessageEl.style.display = 'block';
//     }

//     const tyreIdInput = document.getElementById('etfTyreId');
//     if (tyreIdInput) tyreIdInput.disabled = true;
//     const treadInput = document.getElementById('etfTyreTreadDepth');
//     if (treadInput) treadInput.disabled = true;
//     const flipRotationInput = document.getElementById('etfFlipRotation');
//     if (flipRotationInput) flipRotationInput.disabled = true;
//     const submitBtn = edittyreidform.querySelector('button[type="submit"]');

//     if (submitBtn) submitBtn.disabled = true;

//   } else {
//     // Populate fields as usual
//     document.getElementById('etfTyreId').value = tyreInfo.externalTyreId || "";
//     document.getElementById('etfFlipRotation').checked = !!tyreInfo.flipRotation;

//     const treadDepthValue = tyreInfo.tyreTreadDepth
//       ? parseFloat(tyreInfo.tyreTreadDepth)
//       : 0;
//     document.getElementById('etfTyreTreadDepth').value =
//       treadDepthValue > 0 ? treadDepthValue : 0;
//   }

//   edittyreidform.onsubmit = (e) => {
//     e.stopImmediatePropagation();
//     e.preventDefault();
//     submitEditTyreIdForm(unit, wheel);
//   };

//   document.body.style.cursor = 'default';
//   editTyreInfo.style.display = "block";
// }

// async function submitEditTyreIdForm(unit, wheel) {

//   document.getElementById("loadingBoxText").innerText = "Updating tyre data... ";
//   $("#loadingBox").modal({
//     backdrop: "static", //remove ability to close modal with click
//     keyboard: false, //remove option to close with keyboard
//     show: true //Display loader!
//   });

//   wheel.externalTyreId = document.getElementById('etfTyreId').value;
//   wheel.tyreTreadDepth = document.getElementById('etfTyreTreadDepth').value;
//   wheel.flipRotation = document.getElementById('etfFlipRotation').checked;
//   if (wheel.wheelId.slice(1, 3) === SPARE_AXLE.toString()) {
//     const updatedSpareWheel = unit.spareSensors.find(s => s.wheelId === wheel.wheelId);
//     if (updatedSpareWheel) {
//       updatedSpareWheel.externalTyreId = wheel.externalTyreId;
//       updatedSpareWheel.tyreTreadDepth = wheel.tyreTreadDepth;
//       updatedSpareWheel.flipRotation = wheel.flipRotation;
//     }
//   } else {
//     const updatedWheel = unit.wheelSensors.find(s => s.wheelId === wheel.wheelId);
//     if (updatedWheel) {
//       updatedWheel.externalTyreId = wheel.externalTyreId;
//       updatedWheel.tyreTreadDepth = wheel.tyreTreadDepth;
//       updatedWheel.flipRotation = wheel.flipRotation;
//     }
//   }

//   await updateTyreInfo(wheel);
//   createDiagramView(unit, 'SENSORVALUESDIAGRAM', 'middlepane');

//   $("#loadingBox").modal("hide");
//   document.getElementById("edittyreinfomodal").style.display = "none";
//   return false;
// }

function createStandardSensorFromCurrent(replacedSensor) {  //Create Sensor

  let name = replacedSensor.currentSensorId;
  let type = "custom";
  let param = "tmp_1";

  let obj = { n: name, d: "", f: 0, c: "", vt: 1, vs: 0, tbl: [], m: "", p: param, t: type };
  global.session.getItem(replacedSensor.id).createSensor(obj,
    function (code, data) { // create sensor callback
      if (code) msg(wialon.core.Errors.getErrorText(code));
      else {
        console.log(data.n + " sensor created successfully");
      }
    }
  );
}

async function openActionLogForm(unit, wheel) {

  const actionLogData = unit.unitType === 'TRAILER' || unit.type === 'trailer'
    ? await getStandAloneActionLogData(unit.unitId, wheel.wheelId)
    : await getActionLogData(unit.imei, wheel.wheelId);

  document.body.style.cursor = 'wait';

  let actionlogmodal = document.getElementById('actionlogmodal');

  let span = document.getElementById("closeactionlogmodal");
  span.onclick = function (e) {
    actionlogmodal.style.display = "none";
    e.stopImmediatePropagation();
    return false;
  };

  let actionLogSubmitButton = document.getElementById('alfsubmitbtn');
  actionLogSubmitButton.onclick = (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    submitActionLogForm(unit, wheel.wheelId);
    return false;
  };

  const axleNo = parseInt(wheel.wheelId.slice(1, 3));
  const tyreNo = wheel.wheelId.slice(0, 1);

  let arrHeader = new Array();	// array for header.    
  arrHeader = ['', 'Date', 'Action'];

  let actionLog = document.getElementById('actionlog');
  actionLog.innerText = "";

  let theader = actionLog.createTHead();
  let headerRow = theader.insertRow();
  for (let key of arrHeader) {
    let th = document.createElement('th');
    let text = document.createTextNode(key);
    th.appendChild(text);
    headerRow.appendChild(th);
  }

  let tbody = actionLog.createTBody();

  const hasActions =
    actionLogData &&
    Array.isArray(actionLogData.actions) &&
    actionLogData.actions.length > 0;

  if (hasActions) {
    let itemNo = 0;

    for (let i = actionLogData.actions.length - 1; i >= 0; i--) {
      itemNo++;
      let date = actionLogData.actions[i].timestamp;
      let actionTaken = actionLogData.actions[i].action;

      let tr = tbody.insertRow();

      for (let c = 0; c < arrHeader.length; c++) {
        let cell = tr.insertCell();
        switch (c) {
          case 0:
            cell.textContent = itemNo;
            break;
          case 1:
            cell.textContent = formatZuluTime(date);
            break;
          case 2:
            cell.textContent = actionTaken;
            break;
        }
      }
    }

  } else {
    // 👇 This is the “generic message in the modal” part
    const tr = tbody.insertRow();
    const cell = tr.insertCell();
    cell.colSpan = arrHeader.length;

    // Decide which message to show
    if (actionLogData && actionLogData.error) {

      if (axleNo === SPARE_AXLE) {
        cell.textContent =
          "No actions have been logged for this wheel in the last 6 months.";
        cell.classList.add('text-muted');
      } else {
        // backend / network problem
        cell.textContent =
          "We could not load the notification log for this wheel.";
        cell.style.color = '#ad0505';
        cell.style.fontSize = '0.85rem';
        cell.style.fontStyle = 'italic';
      }

    } else {
      // no error, just no actions
      cell.textContent =
        "No actions have been logged for this wheel in the last 6 months.";
      cell.classList.add('text-muted');
    }

    // if you’re using Bootstrap
    cell.style.textAlign = 'center';
    cell.style.padding = '12px';
  }

  document.getElementById('alfUnitId').value = unit.imei;
  document.getElementById('alfWheelId').value = wheel.wheelId;
  document.getElementById("alfUnitName").value = unit.name;

  let trailerName = "";
  if (parseInt(wheel.unitNumber) > 0) trailerName = `Trailer ${wheel.unitNumber}`;
  document.getElementById("alfTrailerName").value = trailerName;
  document.getElementById("alfTrailerName").removeAttribute('type');

  if (axleNo !== SPARE_AXLE) {
    if (axleNo === UNPAIRED_AXLE) {
      document.getElementById("alfAxleTyreDescription").value = "Unpaired";
    } else {
      document.getElementById("alfAxleTyreDescription").value = "A" + axleNo + "-T" + tyreNo;
    }
  } else {

    document.getElementById("alfAxleTyreDescription").value = "Spare " + tyreNo;
  }

  document.getElementById("actionlogmodal").style.display = "block";
  document.body.style.cursor = 'default';

}

async function submitActionLogForm(unit, wheelId) {

  document.body.style.cursor = 'wait';
  const action = document.getElementById('alfAction').value;

  const updatedActionLog = unit.unitType === 'TRAILER' ? await updateStandAloneActionLog(unit.unitId, wheelId, action) : await updateActionLog(unit.imei, wheelId, action);

  document.getElementById("actionlogmodal").style.display = "none";

  document.getElementById("actionlogform").reset();
  document.body.style.cursor = 'default';

  return false;
}

